import {ReactNode} from "react"
import {observer} from "mobx-react"
import * as ui from "@kroschke/react-ui"
import {apiStatus} from "../../api";
import {growlStore} from "../../store";
import {GrowlMessage} from "@kroschke/react-ui/dist/components/GrowlBar";
import {AccountButton} from "./AccountButton";

export interface Action {
    label: string
    action: () => any
    icon?: string
}

export interface PageProps {
    cssSuffix?: string,
    children?: ReactNode,
    actions?: Action[]
    action?: ReactNode
    topper?: ReactNode
    breadcrumb?: ui.BreadcrumbItem[]
}

const Page = observer(function Page({
                                        cssSuffix,
                                        actions,
                                        action,
                                        topper,
                                        breadcrumb,
                                        children
                                    }: PageProps) {
    const growlMessages = (growlStore.messages || []).map(e => e as GrowlMessage) // this is needed to activate the observer
    return <ui.Page
        apiErrorClear={() => apiStatus.clearErrors()}
        apiErrorTitle={apiStatus.error?.statusText}
        apiErrorMessage={JSON.stringify(apiStatus.error?.data)}
        growlRemove={id => growlStore.remove(id)}
        growlMessages={growlMessages}
        cssSuffix={cssSuffix}
        actions={actions}
        action={<>
            {action}
            <AccountButton />
        </>}
        breadcrumb={breadcrumb}
        topper={topper}
    >{children}</ui.Page>
})

export {
    Page
}
